(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const overlay = drawer.querySelector('[data-cart-drawer-close]');
  const panel = drawer.querySelector('.cart-drawer__panel');
  const itemsRoot = drawer.querySelector('[data-cart-drawer-items]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  const moneyFormat = drawer.getAttribute('data-money-format') || '';
  const emptyText = drawer.getAttribute('data-empty-text') || window.SculptStrings?.cartEmpty || 'Your cart is empty';
  const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
  const checkoutUrl = `${cartUrl}?checkout`;

  let lockedScrollY = 0;
  let isOpen = false;

  const formatMoney = (cents) => {
    const noDecimalFormat = moneyFormat
      .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
      .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{ amount }}', '{{amount_no_decimals}}');

    if (window.Shopify?.formatMoney && noDecimalFormat) {
      return window.Shopify.formatMoney(cents, noDecimalFormat);
    }

    const whole = Math.round(Number(cents || 0) / 100).toString();
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (noDecimalFormat) {
      return noDecimalFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grouped)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    return grouped;
  };

  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const freezeStickyGalleries = () => {
    document.querySelectorAll('.product-gallery-col').forEach((el) => {
      if (el.dataset.sculptStickyFrozen === 'true') return;

      const rect = el.getBoundingClientRect();
      const parent = el.parentNode;
      if (!parent) return;

      /* Placeholder di grid supaya product-info tidak melebar ke kiri.
         Gallery dipindah ke body + fixed di posisi viewport saat ini. */
      const placeholder = document.createElement('div');
      placeholder.className = 'product-gallery-col product-gallery-col--placeholder';
      placeholder.dataset.sculptGalleryPlaceholder = 'true';
      placeholder.style.width = `${Math.round(rect.width)}px`;
      placeholder.style.minHeight = `${Math.round(rect.height)}px`;
      placeholder.setAttribute('aria-hidden', 'true');

      parent.insertBefore(placeholder, el);
      document.body.appendChild(el);

      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', `${Math.round(rect.top)}px`, 'important');
      el.style.setProperty('left', `${Math.round(rect.left)}px`, 'important');
      el.style.setProperty('width', `${Math.round(rect.width)}px`, 'important');
      el.style.setProperty('z-index', '2', 'important');
      el.dataset.sculptStickyFrozen = 'true';
      el._sculptGalleryPlaceholder = placeholder;
    });
  };

  const unfreezeStickyGalleries = () => {
    document.querySelectorAll('.product-gallery-col[data-sculpt-sticky-frozen]').forEach((el) => {
      const placeholder = el._sculptGalleryPlaceholder
        || document.querySelector('[data-sculpt-gallery-placeholder]');

      el.style.removeProperty('position');
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.removeProperty('width');
      el.style.removeProperty('z-index');
      delete el.dataset.sculptStickyFrozen;
      delete el._sculptGalleryPlaceholder;

      if (placeholder?.parentNode) {
        placeholder.parentNode.insertBefore(el, placeholder);
        placeholder.remove();
      }
    });

    document.querySelectorAll('[data-sculpt-gallery-placeholder]').forEach((el) => el.remove());
  };

  const lockPageScroll = () => {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;

    const header = document.querySelector('header.header');
    if (header?.classList.contains('header--scrolled')) {
      header.classList.add('header--drawer-preserve-scrolled');
    }

    /* Freeze sticky PDP gallery sebelum body position:fixed,
       supaya gambar tidak loncat naik saat scroll dikunci. */
    freezeStickyGalleries();

    document.documentElement.classList.add('is-cart-drawer-open');
    document.body.classList.add('is-cart-drawer-open');
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockPageScroll = () => {
    const y = lockedScrollY;
    document.documentElement.classList.remove('is-cart-drawer-open');
    document.body.classList.remove('is-cart-drawer-open');
    document.body.style.removeProperty('top');
    document.querySelector('header.header')?.classList.remove('header--drawer-preserve-scrolled');

    unfreezeStickyGalleries();

    // theme.css pakai scroll-behavior:smooth — tanpa 'instant',
    // restore posisi kelihatan seperti auto-scroll ke bawah.
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    window.dispatchEvent(new Event('scroll'));
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.header__icon-btn--cart').forEach((button) => {
      let badge = button.querySelector('.header__cart-count');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          button.appendChild(badge);
        }
        badge.textContent = String(count);
        badge.hidden = false;
      } else if (badge) {
        badge.remove();
      }
    });
  };

  const itemImage = (item) => {
    if (!item.image) return '';
    return item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_160x$1$2');
  };

  const displayOptionValue = (value) => {
    const raw = String(value || '').trim();
    const hexMatch = raw.match(/^#?([0-9A-Fa-f]{6})_(.+)$/);
    return hexMatch ? hexMatch[2] : raw;
  };

  const itemVariantLabel = (item) => {
    if (!item.options_with_values?.length || item.product_has_only_default_variant) return '';
    const values = item.options_with_values.map((option) => displayOptionValue(option.value)).filter(Boolean);
    if (!values.length || values.join(' / ') === 'Default Title') return '';
    return `- ${values.join(', ')}`;
  };

  const renderItems = (cart) => {
    if (!itemsRoot) return;

    if (!cart.items?.length) {
      itemsRoot.innerHTML = `<p class="cart-drawer__empty">${escapeHtml(emptyText)}</p>`;
      footer?.setAttribute('hidden', '');
      return;
    }

    const list = cart.items
      .map((item) => {
        const image = itemImage(item);
        const variant = itemVariantLabel(item);

        return `
          <li class="cart-drawer__item" data-line-key="${escapeHtml(item.key)}">
            <a class="cart-drawer__thumb" href="${escapeHtml(item.url)}">
              ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="72" height="72">` : ''}
            </a>
            <div class="cart-drawer__details">
              <a class="cart-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
              ${variant ? `<p class="cart-drawer__variant">${escapeHtml(variant)}</p>` : ''}
              <div class="cart-drawer__meta-row">
                <p class="cart-drawer__meta">${item.quantity} x ${formatMoney(item.final_price)}</p>
                <button
                  type="button"
                  class="cart-drawer__remove"
                  data-cart-remove="${escapeHtml(item.key)}"
                  aria-label="Remove ${escapeHtml(item.product_title)}"
                >
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </li>
        `;
      })
      .join('');

    itemsRoot.innerHTML = `<ul class="cart-drawer__list">${list}</ul>`;
    footer?.removeAttribute('hidden');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  };

  const fetchCart = async () => {
    const response = await fetch(`${cartUrl}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(window.SculptStrings?.cartErrorLoad || 'Unable to load cart');
    return response.json();
  };

  const refreshCart = async () => {
    const cart = await fetchCart();
    renderItems(cart);
    updateCartCount(cart.item_count);
    return cart;
  };

  const openDrawer = async () => {
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });

    if (!isOpen) {
      lockPageScroll();
      isOpen = true;
    }

    panel?.focus();

    try {
      await refreshCart();
    } catch (error) {
      console.error(error);
    }
  };

  const closeDrawer = () => {
    // Lepas fokus dari tombol X supaya browser tidak scroll ke elemen fokus
    if (drawer.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    drawer.classList.remove('is-open');
    isOpen = false;
    unlockPageScroll();

    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
      }
    }, 320);
  };

  const addToCart = async (form) => {
    const formData = new FormData(form);
    const response = await fetch(`${cartUrl}/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || window.SculptStrings?.cartErrorAdd || 'Unable to add to cart');
    }

    await openDrawer();
  };

  const removeItem = async (key) => {
    const response = await fetch(`${cartUrl}/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });

    if (!response.ok) throw new Error(window.SculptStrings?.cartErrorRemove || 'Unable to remove item');

    const cart = await response.json();
    renderItems(cart);
    updateCartCount(cart.item_count);
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-cart-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeItem(removeBtn.getAttribute('data-cart-remove')).catch((error) => {
        console.error(error);
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) {
      closeDrawer();
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-product-form], form[action*="/cart/add"]')) return;

      const submitter = event.submitter;
      if (submitter?.closest('.shopify-payment-button')) return;
      if (submitter && !submitter.matches('[data-product-submit], [name="add"]')) return;

      event.preventDefault();

      const submitBtn = form.querySelector('[data-product-submit], [type="submit"]');
      const variantSelect = form.querySelector('[data-variant-id-select]');
      const canSubmit = Boolean(variantSelect && variantSelect.value);
      if (!canSubmit) return;
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

      addToCart(form)
        .catch((error) => {
          console.error(error);
          window.alert(error.message);
        })
        .finally(() => {
          if (!submitBtn) return;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = !variantSelect.value;
        });
    },
    true
  );

  overlay?.addEventListener('click', closeDrawer);
})();
